require("./brokerCustomWalletPortfolioItem.scss");

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');

// @ commons
const { Toggle } = require('commonsComponents/toggle');
const  OKTag = require('components/commons/OKTag/OKTag');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

class BrokerCustomWalletPortfolioItem extends React.Component {

    constructor(props) {
        super(props);

        this.handleClickViewInterveners = this.handleClickViewInterveners.bind(this);
    }

    handleClickViewInterveners() {
        const { contractNumber } = this.props;
        this.props.getInterveners(contractNumber);
    }

    render() {
        const { contractName, contractNumberFormatted, switchEnabled, handleClick, toggleAvailable, interventionType, creatingNew, personalizable, showUnconsolidatedTooltip } = this.props;
        const newClass = classNames(
            'col-md-1 custom-wallet-portfolio-item__toggle',
            {
                'toggle-available': !toggleAvailable
            }
        );

        const parsedContractNumber = contractNumberFormatted.substring(0, 4) + ' ' + contractNumberFormatted.substring(4, 8) + ' ' + contractNumberFormatted.substring(8);
        const intervenersLink = formatText('brokerCustomWallet-intervenersLink');
        let interventionTypeTag;

        if (!!interventionType) {
            const interventionTypeTagLabel = <FormattedText value="broker-interventionContractType" apiValue={interventionType.trim()} />

            interventionTypeTag = <OKTag content={interventionTypeTagLabel} context="arrow" />;
        }

        let nameClassModifier = 'col-md-5 custom-wallet-portfolio-item__data';
        let toggle = (
            <div className={newClass}>
                <Toggle checked={switchEnabled} onClick={handleClick} />
            </div>
        );

        if (showUnconsolidatedTooltip) {
            const toggleTooltipTarget = (
                <div className={newClass}>
                    <Toggle checked={switchEnabled} onClick={handleClick} />
                </div>
            );
            const toggleTooltipContent = creatingNew ? "brokerCustomWallet-unconsolidatedContractCreation"
                : "brokerCustomWallet-unconsolidatedContractEdition";
            toggle = (
                <OKTooltip
                    target={toggleTooltipTarget}
                    content={toggleTooltipContent}
                    placement="right"
                    offset={[-15,0]}
                />
            );
        }

        if (!personalizable) {
            nameClassModifier = nameClassModifier + '__unconsolidated';
        }

        return (
            <div className="row custom-wallet-portfolio-item">
                <div className={nameClassModifier}>
                    <div className="row custom-wallet-portfolio-item__name">{contractName}</div>
                    <div className="row custom-wallet-portfolio-item__number">{parsedContractNumber}</div>
                </div>
                <div className="col-md-3 custom-wallet-portfolio-item__tag">
                    {interventionTypeTag}
                </div>
                <div className="col-md-3 custom-wallet-portfolio-item__interveners">
                    <span className="custom-wallet-portfolio-item__interveners-name" onClick={this.handleClickViewInterveners}>
                        {intervenersLink}
                    </span>
                </div>
                {toggle}
            </div>
        );
    }
}

BrokerCustomWalletPortfolioItem.propTypes = {
    contractName: PropTypes.string.isRequired,
    contractNumber: PropTypes.string.isRequired,
    contractNumberFormatted: PropTypes.string.isRequired,
    switchEnabled: PropTypes.bool,
    interventionType: PropTypes.string,
    handleClick: PropTypes.func,
    toggleAvailable: PropTypes.bool,
    getInterveners: PropTypes.func.isRequired,
    creatingNew: PropTypes.bool,
    personalizable: PropTypes.bool,
    showUnconsolidatedTooltip: PropTypes.bool
};

BrokerCustomWalletPortfolioItem.defaultProps = {
    switchEnabled: true,
    toggleAvailable: true,
}

module.exports = BrokerCustomWalletPortfolioItem;
